// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arm-modal {
  font-size: 0.85rem;
}
.arm-loading {
  text-align: center;
  padding: 30px;
  color: #999;
}
.arm-flags {
  margin: 12px 0;
  border-radius: 8px;
  border: 1px solid #ededed;
  overflow: hidden;
}
.arm-flags-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #fafafa;
  border-bottom: 1px solid #ededed;
}
.arm-flags-title {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #171717;
}
.arm-flags-count {
  font-size: 0.72rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid rgba(220, 38, 38, 0.2);
}
.arm-flags-count.arm-flags-clean {
  background: #f0fdf4;
  color: #16a34a;
  border-color: rgba(22, 163, 74, 0.2);
}
.arm-flag {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 6px 12px;
  font-size: 0.78rem;
  border-bottom: 1px solid #f5f5f5;
}
.arm-flag:last-child {
  border-bottom: none;
}
.arm-flag-icon {
  flex-shrink: 0;
  font-size: 0.9rem;
  line-height: 1.4;
}
.arm-flag-msg {
  flex: 1;
  line-height: 1.4;
}
.arm-flag-danger {
  background: #fef2f2;
  color: #dc2626;
  font-weight: 600;
}
.arm-flag-warn {
  background: #fffbeb;
  color: #ea580c;
}
.arm-flag-info {
  background: #f0f9ff;
  color: #0369a1;
}
.arm-flags-clean-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 12px;
  background: #f0fdf4;
  border: 1px solid rgba(22, 163, 74, 0.2);
  border-radius: 8px;
  color: #16a34a;
  font-size: 0.82rem;
  font-weight: 600;
}
.arm-summary {
  margin-bottom: 16px;
}
.arm-summary-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 12px;
}
.arm-field {
  display: flex;
  flex-direction: column;
}
.arm-label {
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #999;
}
.arm-value {
  font-weight: 700;
  color: #171717;
}
.arm-income-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.arm-income-card {
  flex: 1 1 100px;
  padding: 10px 14px;
  background: #fafafa;
  border: 1px solid #ededed;
  border-radius: 8px;
  text-align: center;
}
.arm-income-primary {
  background: #f0f0ff;
  border-color: rgba(93, 77, 128, 0.2);
}
.arm-income-label {
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #999;
  margin-bottom: 2px;
}
.arm-income-amount {
  font-size: 1.1rem;
  font-weight: 800;
  color: #171717;
}
.arm-aligned {
  color: #16a34a;
}
.arm-not-aligned {
  color: #ea580c;
}
.arm-delta-warn {
  color: #ea580c;
  font-weight: 700;
}
.arm-delta-danger {
  color: #dc2626;
  font-weight: 700;
}
.arm-section {
  margin-top: 16px;
}
.arm-section-title {
  font-size: 0.78rem;
  font-weight: 700;
  margin-bottom: 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid #ededed;
}
.arm-draft {
  padding: 8px 12px;
  border: 1px solid #ededed;
  border-radius: 6px;
  margin-bottom: 6px;
  background: #fff;
}
.arm-draft-excluded {
  background: #fef2f2;
  border-color: rgba(220, 38, 38, 0.15);
}
.arm-draft-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.arm-draft-type {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #5d4d80;
  min-width: 90px;
}
.arm-draft-employer {
  flex: 1;
  font-weight: 600;
}
.arm-draft-amount {
  font-weight: 800;
  color: #171717;
}
.arm-draft-reason {
  font-size: 0.78rem;
  color: #dc2626;
  font-weight: 600;
}
.arm-draft-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 0.72rem;
  color: #999;
  margin-top: 4px;
}
.arm-draft-notes {
  font-size: 0.75rem;
  color: #666;
  margin-top: 4px;
  font-style: italic;
}
.arm-issue {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  background: #fffbeb;
  border: 1px solid rgba(234, 136, 12, 0.2);
  border-radius: 6px;
  margin-bottom: 4px;
  font-size: 0.78rem;
}
.arm-issue-defect {
  font-weight: 700;
  color: #ea580c;
}
.arm-issue-desc {
  flex: 1;
}
.arm-issue-by {
  font-size: 0.68rem;
  color: #999;
}
.arm-footer {
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  padding: 1rem !important;
}
.arm-audit-actions {
  width: 100%;
}
.arm-rating-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}
.arm-rating-label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #666;
  margin-right: 4px;
}
.arm-rating-panels {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  margin-bottom: 10px;
}
.arm-rating-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 14px 10px;
  border-radius: 10px;
  border: 2px solid #ededed;
  background: #fafafa;
  cursor: pointer;
  transition: all 150ms ease;
}
.arm-rating-panel:hover {
  border-color: #ccc;
  background: #f0f0f0;
  transform: translateY(-1px);
}
.arm-panel-icon {
  font-size: 1.4rem;
  line-height: 1;
}
.arm-panel-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: #171717;
}
.arm-panel-pass.arm-panel-selected {
  background: #f0fdf4;
  border-color: #16a34a;
  box-shadow: 0 0 0 1px rgba(22, 163, 74, 0.2);
}
.arm-panel-pass.arm-panel-selected .arm-panel-label {
  color: #16a34a;
}
.arm-panel-concerns.arm-panel-selected {
  background: #fffbeb;
  border-color: #ea580c;
  box-shadow: 0 0 0 1px rgba(234, 136, 12, 0.2);
}
.arm-panel-concerns.arm-panel-selected .arm-panel-label {
  color: #ea580c;
}
.arm-panel-fail.arm-panel-selected {
  background: #fef2f2;
  border-color: #dc2626;
  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.2);
}
.arm-panel-fail.arm-panel-selected .arm-panel-label {
  color: #dc2626;
}
.arm-audit-notes {
  margin-bottom: 8px;
  font-size: 0.82rem;
}
.arm-mark-error {
  font-size: 0.78rem;
  color: #dc2626;
  margin-bottom: 6px;
}
.arm-marking {
  font-size: 0.78rem;
  color: #999;
  margin-bottom: 6px;
}
.arm-footer-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.arm-audited-result {
  text-align: center;
  padding: 8px 0;
}
.arm-audited-badge {
  display: inline-block;
  padding: 6px 20px;
  border-radius: 999px;
  font-size: 0.88rem;
  font-weight: 700;
}
.arm-audited-pass {
  background: #f0fdf4;
  color: #16a34a;
  border: 1px solid rgba(22, 163, 74, 0.3);
}
.arm-audited-concerns {
  background: #fffbeb;
  color: #ea580c;
  border: 1px solid rgba(234, 136, 12, 0.3);
}
.arm-audited-fail {
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid rgba(220, 38, 38, 0.3);
}
.arm-audited-meta {
  font-size: 0.72rem;
  color: #999;
  margin-top: 6px;
}
.arm-audited-notes {
  font-size: 0.78rem;
  color: #666;
  font-style: italic;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/app/audit-module/audit-review-modal/audit-review-modal.component.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAEA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;AAAF;AAIA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAFF;AAKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;AAHF;AAMA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAJF;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,wCAAA;AALF;AAOE;EACE,mBAAA;EACA,cAAA;EACA,oCAAA;AALJ;AASA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;AAPF;AASE;EAAe,mBAAA;AANjB;AASA;EAAiB,cAAA;EAAgB,iBAAA;EAAmB,gBAAA;AAJpD;AAKA;EAAgB,OAAA;EAAS,gBAAA;AADzB;AAGA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AADF;AAIA;EACE,mBAAA;EACA,cAAA;AAFF;AAKA;EACE,mBAAA;EACA,cAAA;AAHF;AAMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAJF;AAQA;EACE,mBAAA;AANF;AASA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AAPF;AAUA;EACE,aAAA;EACA,sBAAA;AARF;AAWA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;AATF;AAYA;EACE,gBAAA;EACA,cAAA;AAVF;AAcA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAZF;AAeA;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AAbF;AAgBA;EACE,mBAAA;EACA,oCAAA;AAdF;AAiBA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;AAfF;AAkBA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAhBF;AAmBA;EAAe,cAAA;AAhBf;AAiBA;EAAmB,cAAA;AAdnB;AAeA;EAAkB,cAAA;EAAgB,gBAAA;AAXlC;AAYA;EAAoB,cAAA;EAAgB,gBAAA;AARpC;AAWA;EACE,gBAAA;AATF;AAYA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;AAVF;AAcA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAZF;AAeA;EACE,mBAAA;EACA,qCAAA;AAbF;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAdF;AAiBA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AAfF;AAkBA;EACE,OAAA;EACA,gBAAA;AAhBF;AAmBA;EACE,gBAAA;EACA,cAAA;AAjBF;AAoBA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AAlBF;AAqBA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAnBF;AAsBA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AApBF;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAtBF;AAyBA;EACE,gBAAA;EACA,cAAA;AAvBF;AA0BA;EACE,OAAA;AAxBF;AA2BA;EACE,kBAAA;EACA,WAAA;AAzBF;AA6BA;EACE,sBAAA;EACA,oBAAA;EACA,SAAA;EACA,wBAAA;AA3BF;AA8BA;EACE,WAAA;AA5BF;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AA7BF;AAgCA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AA9BF;AAiCA;EACE,aAAA;EACA,kCAAA;EACA,SAAA;EACA,mBAAA;AA/BF;AAkCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;AAhCF;AAkCE;EACE,kBAAA;EACA,mBAAA;EACA,2BAAA;AAhCJ;AAoCA;EACE,iBAAA;EACA,cAAA;AAlCF;AAqCA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAnCF;AAsCA;EACE,mBAAA;EACA,qBAAA;EACA,4CAAA;AApCF;AAiCA;EAIqB,cAAA;AAlCrB;AAqCA;EACE,mBAAA;EACA,qBAAA;EACA,6CAAA;AAnCF;AAgCA;EAIqB,cAAA;AAjCrB;AAoCA;EACE,mBAAA;EACA,qBAAA;EACA,4CAAA;AAlCF;AA+BA;EAIqB,cAAA;AAhCrB;AAmCA;EACE,kBAAA;EACA,kBAAA;AAjCF;AAoCA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AAlCF;AAqCA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;AAnCF;AAsCA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;AApCF;AAwCA;EACE,kBAAA;EACA,cAAA;AAtCF;AAyCA;EACE,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAvCF;AA0CA;EACE,mBAAA;EACA,cAAA;EACA,wCAAA;AAxCF;AA2CA;EACE,mBAAA;EACA,cAAA;EACA,yCAAA;AAzCF;AA4CA;EACE,mBAAA;EACA,cAAA;EACA,wCAAA;AA1CF;AA6CA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AA3CF;AA8CA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AA5CF","sourcesContent":[".arm-modal {\n  font-size: 0.85rem;\n}\n\n.arm-loading {\n  text-align: center;\n  padding: 30px;\n  color: #999;\n}\n\n// ── SOP Flags ──\n.arm-flags {\n  margin: 12px 0;\n  border-radius: 8px;\n  border: 1px solid #ededed;\n  overflow: hidden;\n}\n\n.arm-flags-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  background: #fafafa;\n  border-bottom: 1px solid #ededed;\n}\n\n.arm-flags-title {\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #171717;\n}\n\n.arm-flags-count {\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #fef2f2;\n  color: #dc2626;\n  border: 1px solid rgba(220, 38, 38, 0.2);\n\n  &.arm-flags-clean {\n    background: #f0fdf4;\n    color: #16a34a;\n    border-color: rgba(22, 163, 74, 0.2);\n  }\n}\n\n.arm-flag {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 6px 12px;\n  font-size: 0.78rem;\n  border-bottom: 1px solid #f5f5f5;\n\n  &:last-child { border-bottom: none; }\n}\n\n.arm-flag-icon { flex-shrink: 0; font-size: 0.9rem; line-height: 1.4; }\n.arm-flag-msg { flex: 1; line-height: 1.4; }\n\n.arm-flag-danger {\n  background: #fef2f2;\n  color: #dc2626;\n  font-weight: 600;\n}\n\n.arm-flag-warn {\n  background: #fffbeb;\n  color: #ea580c;\n}\n\n.arm-flag-info {\n  background: #f0f9ff;\n  color: #0369a1;\n}\n\n.arm-flags-clean-banner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 12px;\n  background: #f0fdf4;\n  border: 1px solid rgba(22, 163, 74, 0.2);\n  border-radius: 8px;\n  color: #16a34a;\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n// Summary\n.arm-summary {\n  margin-bottom: 16px;\n}\n\n.arm-summary-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.arm-field {\n  display: flex;\n  flex-direction: column;\n}\n\n.arm-label {\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #999;\n}\n\n.arm-value {\n  font-weight: 700;\n  color: #171717;\n}\n\n// Income cards\n.arm-income-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.arm-income-card {\n  flex: 1 1 100px;\n  padding: 10px 14px;\n  background: #fafafa;\n  border: 1px solid #ededed;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.arm-income-primary {\n  background: #f0f0ff;\n  border-color: rgba(93, 77, 128, 0.2);\n}\n\n.arm-income-label {\n  font-size: 0.62rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #999;\n  margin-bottom: 2px;\n}\n\n.arm-income-amount {\n  font-size: 1.1rem;\n  font-weight: 800;\n  color: #171717;\n}\n\n.arm-aligned { color: #16a34a; }\n.arm-not-aligned { color: #ea580c; }\n.arm-delta-warn { color: #ea580c; font-weight: 700; }\n.arm-delta-danger { color: #dc2626; font-weight: 700; }\n\n// Sections\n.arm-section {\n  margin-top: 16px;\n}\n\n.arm-section-title {\n  font-size: 0.78rem;\n  font-weight: 700;\n  margin-bottom: 8px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid #ededed;\n}\n\n// Drafts\n.arm-draft {\n  padding: 8px 12px;\n  border: 1px solid #ededed;\n  border-radius: 6px;\n  margin-bottom: 6px;\n  background: #fff;\n}\n\n.arm-draft-excluded {\n  background: #fef2f2;\n  border-color: rgba(220, 38, 38, 0.15);\n}\n\n.arm-draft-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.arm-draft-type {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #5d4d80;\n  min-width: 90px;\n}\n\n.arm-draft-employer {\n  flex: 1;\n  font-weight: 600;\n}\n\n.arm-draft-amount {\n  font-weight: 800;\n  color: #171717;\n}\n\n.arm-draft-reason {\n  font-size: 0.78rem;\n  color: #dc2626;\n  font-weight: 600;\n}\n\n.arm-draft-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  font-size: 0.72rem;\n  color: #999;\n  margin-top: 4px;\n}\n\n.arm-draft-notes {\n  font-size: 0.75rem;\n  color: #666;\n  margin-top: 4px;\n  font-style: italic;\n}\n\n// Issues\n.arm-issue {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 10px;\n  background: #fffbeb;\n  border: 1px solid rgba(234, 136, 12, 0.2);\n  border-radius: 6px;\n  margin-bottom: 4px;\n  font-size: 0.78rem;\n}\n\n.arm-issue-defect {\n  font-weight: 700;\n  color: #ea580c;\n}\n\n.arm-issue-desc {\n  flex: 1;\n}\n\n.arm-issue-by {\n  font-size: 0.68rem;\n  color: #999;\n}\n\n// ── Footer / Mark Audited ──\n.arm-footer {\n  flex-direction: column;\n  align-items: stretch;\n  gap: 10px;\n  padding: 1rem !important;\n}\n\n.arm-audit-actions {\n  width: 100%;\n}\n\n.arm-rating-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.arm-rating-label {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #666;\n  margin-right: 4px;\n}\n\n.arm-rating-panels {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.arm-rating-panel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 14px 10px;\n  border-radius: 10px;\n  border: 2px solid #ededed;\n  background: #fafafa;\n  cursor: pointer;\n  transition: all 150ms ease;\n\n  &:hover {\n    border-color: #ccc;\n    background: #f0f0f0;\n    transform: translateY(-1px);\n  }\n}\n\n.arm-panel-icon {\n  font-size: 1.4rem;\n  line-height: 1;\n}\n\n.arm-panel-label {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #171717;\n}\n\n.arm-panel-pass.arm-panel-selected {\n  background: #f0fdf4;\n  border-color: #16a34a;\n  box-shadow: 0 0 0 1px rgba(22, 163, 74, 0.2);\n  .arm-panel-label { color: #16a34a; }\n}\n\n.arm-panel-concerns.arm-panel-selected {\n  background: #fffbeb;\n  border-color: #ea580c;\n  box-shadow: 0 0 0 1px rgba(234, 136, 12, 0.2);\n  .arm-panel-label { color: #ea580c; }\n}\n\n.arm-panel-fail.arm-panel-selected {\n  background: #fef2f2;\n  border-color: #dc2626;\n  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.2);\n  .arm-panel-label { color: #dc2626; }\n}\n\n.arm-audit-notes {\n  margin-bottom: 8px;\n  font-size: 0.82rem;\n}\n\n.arm-mark-error {\n  font-size: 0.78rem;\n  color: #dc2626;\n  margin-bottom: 6px;\n}\n\n.arm-marking {\n  font-size: 0.78rem;\n  color: #999;\n  margin-bottom: 6px;\n}\n\n.arm-footer-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n// ── Audited result display ──\n.arm-audited-result {\n  text-align: center;\n  padding: 8px 0;\n}\n\n.arm-audited-badge {\n  display: inline-block;\n  padding: 6px 20px;\n  border-radius: 999px;\n  font-size: 0.88rem;\n  font-weight: 700;\n}\n\n.arm-audited-pass {\n  background: #f0fdf4;\n  color: #16a34a;\n  border: 1px solid rgba(22, 163, 74, 0.3);\n}\n\n.arm-audited-concerns {\n  background: #fffbeb;\n  color: #ea580c;\n  border: 1px solid rgba(234, 136, 12, 0.3);\n}\n\n.arm-audited-fail {\n  background: #fef2f2;\n  color: #dc2626;\n  border: 1px solid rgba(220, 38, 38, 0.3);\n}\n\n.arm-audited-meta {\n  font-size: 0.72rem;\n  color: #999;\n  margin-top: 6px;\n}\n\n.arm-audited-notes {\n  font-size: 0.78rem;\n  color: #666;\n  font-style: italic;\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
